export default __webpack_public_path__ + "static/media/הילדיםשלי.222f8652.mp3";